import React from 'react';

import {
    Transfer
} from 'antd';

class ColumnSelector extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            /**
             * {
             *  chosen: Boolean,
             *  description: String,
             *  key: String,
             *  title: String
             * }
             */
            data: [],
        }
    }

    render() {

        const {fieldNames} = this.props

        const data = fieldNames.map(_fieldName => {
            return {
                chosen: this.props.DEFAULT_COLUMNS.includes(_fieldName.key),
                description: '',
                key: _fieldName.key,
                title: _fieldName.key,
            }
        })

        return (
            <Transfer
                dataSource={data}
                titles={['Available Columns', 'Selected Columns']}
                listStyle={{
                    width: '48%',
                    height: 250,
                  }}
                showSearch
                filterOption={this.filterOption}
                targetKeys={this.props.selectedFields}
                onChange={this.handleChange}
                onSearch={this.handleSearch}
                render={this.renderItem}
            />
        )
    }

    renderItem = item => {
        const customLabel = (
            <span className="custom-item">
                {item.title}
            </span>
        );

        return {
            label: customLabel, // for displayed item
            value: item.title, // for title and filter matching
        };
    };

    filterOption = (inputValue, option) => {
        return option.key.indexOf(inputValue) > -1
    }

    handleChange = (targetKeys, direction, moveKeys) => {

        var originalTargetKeys, newTargetKeys

        if (direction==='right') {
            originalTargetKeys = this.props.selectedFields
            newTargetKeys = [...originalTargetKeys,...moveKeys]
        } else {
            newTargetKeys = targetKeys
        }
        
        this.props.onColumnSelectedChange(newTargetKeys)

    };

    handleSearch = (dir, value) => {
        console.log('search:', dir, value);
    };
      
}

export default ColumnSelector


// WEBPACK FOOTER //
// ./src/components/data/column-selector.js